<script setup lang="ts">
import { useUiStore } from '@/stores/ui'

const ui = useUiStore()
</script>

<template>
  <nav
    v-if="ui.breadcrumbs.length"
    class="flex items-center gap-1 text-xs min-w-0 sm:gap-1.5 sm:text-sm"
  >
    <template
      v-for="(crumb, index) in ui.breadcrumbs"
      :key="index"
    >
      <span
        v-if="index > 0"
        class="plutto-icon plutto-icon--outlined text-base text-gray-400"
      >chevron_right</span>
      <router-link
        v-if="crumb.to"
        :to="crumb.to"
        class="truncate text-gray-500 hover:text-indigo-700"
      >
        {{ crumb.label }}
      </router-link>
      <span
        v-else
        class="truncate font-medium text-gray-900"
      >{{ crumb.label }}</span>
    </template>
  </nav>
</template>
